// Reading an error answer from /api/v5, whichever body the server sends (V6 plan 13.3.1 "The
// wire" → Errors, H.16). The one error body `{code, status, message, data, traceId}` replaces
// two: the RPC wire's `{defined, code, status, message, data}` (inside `{"json": …}` in the RPC
// encoding, bare on the plain JSON wire) and the hand-written routes' `{code, params, traceId}`.
// In all three the code a client branches on (`run_not_found`, `command_in_progress`) is `code`,
// so a client that reads all three is deployed before the server changes its body and still
// reads a server from before it. oRPC's own RPC decoder takes only its error object: the one
// body's `traceId` makes it fall back to the oRPC code of the status (`NOT_FOUND`, `CONFLICT`)
// with the whole answer under `data.body`, so a client reads a refusal from the response before
// the decoder sees it.
const isRecord = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
/**
 * An error answer's parsed JSON body, bare or inside the RPC encoding's `{"json": …}`: the one
 * body, the RPC wire's `{defined, code, status, message, data}` or the hand-written routes'
 * `{code, params, traceId}`. `status` is the response's own; a body that carries no trace id
 * takes `requestId`, the response's x-request-id header. Null when the body names no code (a
 * proxy's page, an empty body), so the caller says `HTTP_<status>`.
 */
export function readApiError(status, body, requestId) {
    if (!isRecord(body))
        return null;
    const inner = isRecord(body.json) ? body.json : body;
    const code = inner.code;
    if (typeof code !== "string" || code.length === 0)
        return null;
    const data = isRecord(inner.data) ? inner.data : isRecord(inner.params) ? inner.params : {};
    const traceId = typeof inner.traceId === "string" && inner.traceId.length > 0 ? inner.traceId : requestId;
    return {
        code,
        status,
        message: typeof inner.message === "string" ? inner.message : code,
        data,
        ...(traceId ? { traceId } : {}),
    };
}
//# sourceMappingURL=errors.js.map